/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Enum_Billingrhytm_Once_CustomInputs */



/**

* @param {_Enum_Billingrhytm_Once_CustomInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _enum_billingrhytm_once_custom = /** @type {((inputs?: _Enum_Billingrhytm_Once_CustomInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Enum_Billingrhytm_Once_CustomInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Einmalig")
});